import PlayArrowRounded from '@mui/icons-material/PlayArrowRounded'
import Box from '@mui/material/Box'
import React from 'react'

import { useResolvedMediaUrl } from 'components/exceptions/hooks/useResolvedVisionThumbnail'

// Playback happens in the gallery; this tile only signals a video, over Vision's THUMBNAIL poster.
type ExceptionVideoSlideProps = {
  height?: number | string
  thumbnailUri?: string
}

const playBadgeSx = {
  alignItems: 'center',
  bgcolor: 'rgba(255, 255, 255, 0.25)',
  borderRadius: '50%',
  display: 'flex',
  height: 48,
  justifyContent: 'center',
  width: 48,
}

const tileSx = (height: number | string, poster: string): object => ({
  alignItems: 'center',
  bgcolor: 'common.black',
  display: 'flex',
  height,
  justifyContent: 'center',
  width: '100%',
  ...(poster && { backgroundImage: `url(${poster})`, backgroundSize: 'cover', backgroundPosition: 'center' }),
})

const ExceptionVideoSlide: React.FC<ExceptionVideoSlideProps> = ({ height = 194, thumbnailUri }) => {
  const poster = useResolvedMediaUrl(thumbnailUri)
  return (
    <swiper-slide lazy="false">
      <Box sx={tileSx(height, poster)}>
        <Box sx={playBadgeSx}>
          <PlayArrowRounded fontSize="large" sx={{ color: 'common.white' }} />
        </Box>
      </Box>
    </swiper-slide>
  )
}

export default ExceptionVideoSlide
